// extracted by mini-css-extract-plugin
export default {"bus_seat_select_container":"bus-seat-select_bus_seat_select_container__GCiLu","deck":"bus-seat-select_deck__lNDdw","deck_container":"bus-seat-select_deck_container__jwk5a"};